<template>
    <div id="app">                      
        <topbar v-if="$route.path !== '/' || $route.name !=='login'" :class="{ 'hide': $route.path === '/' || $route.name ==='login' }"></topbar>
        <notifications group="info" classes="vue-notification" position="top center" :speed="500" />
        <router-view></router-view>
        <div v-if="loginAgain" class="modal">
            <div class="modal-overlay">
                <div class="modal-dialog">
                    <div class="modal-header">
                        <h2 class="text-center">Log ind</h2>
                    </div>
                    <div class="modal-content">
                        <p class="text-center">Du har været inaktiv for længe.<br />Af sikkerhedsmæssige årsager skal du indtaste din adgangskode igen.</p>
                        <form class="login-container">
                            <div class="input-svg">
                                <icon class="locked small-svg" name="locked"></icon>
                                <input type="password" class="password" placeholder="Adgangskode" autofocus v-model="password">
                            </div>
                        </form>
                    </div>
                    <div class="modal-buttons">
                        <button type="button" @click="onSubmit()" class="button button-primary">{{loginMessage}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/store/api.js'
import topbar from './components/topbar/topbar'

export default {
    name: 'app',
    components: {
        topbar
    },
    data () {
        return {
            loginMessage: 'Log ind',
            password: ''
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            loginAgain: 'getLoginAgain'
        })
    },
    methods: {
        ...mapActions({
            setLoginAgain: 'setLoginAgain'
        }),
        async onSubmit () {
            try {
                if (this.password.trim() !== '') {
                    this.loginMessage = 'Logger ind...'
                    let user = {
                        username: this.userInfo.username || this.userInfo.name,
                        password: this.password,
                        rememberme: false
                    }
                    await axios.post('/Account/SignIn', user)
                    this.loginMessage = 'Log ind'
                    this.setLoginAgain(false)
                }
            } catch (err) {
                this.loginMessage = 'Fejl i login'
                setTimeout(() => {
                    this.loginMessage = 'Log ind'
                }, 2500)
            }
        }
    },
    mounted () {
        window.$(document).foundation()
    }
}
</script>

<style lang="scss">
    @import './scss/main';

    .modal {
        display: block;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        z-index: 99999;
        background: rgba(0,0,0,0.2);

        .modal-overlay {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .modal-dialog {
                width: auto;
                height: auto;
                min-width: 800px;
                margin: 0 auto;
                padding: 20px 30px;
                background-color: #fff;
                border-radius: 2px;
                position: relative;
                box-shadow: 0 2px 8px rgba(0,0,0,.33);
                transition: all .3s ease;
                -moz-transition: all .3s ease;
                -o-transition: all .3s ease;
                -webkit-transition: all .3s ease;

                .modal-header {
                    margin-top: 10px;
                    margin-bottom: 20px;
                    text-transform: uppercase;
                    font-size: 1.2rem;
                    text-align: center;
                    font-weight: bold;
                }

                .modal-content {
                    .input-svg {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;

                        svg {
                            margin-right: 15px;
                        }

                        input {
                            margin-bottom: 0px;
                        }
                    }
                }

                .modal-buttons {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 50px;

                    button {
                        margin-left: 5px;
                        margin-right: 5px;
                        border: 0;
                        padding: 9px 27px;
                        border-radius: 4px;
                        min-height: 35px;
                        font-size: 1rem;

                        &:first-of-type {
                            color: #fff;
                        }

                        &.button-secondary {
                            &:hover, &:active, &:focus {
                                background-color: transparent;
                                color: #367ABD;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/App.vue